<template>
  <div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <h3 id="clientFormHeader" class="ang-heading mt-5">Wybierz rodzaje ubezpieczeń, których potrzebujesz</h3>
    <div class="insurance-grid">
      <div class="insurance-item">
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('car'), 'dimmed': !this.insurances.includes('car') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="car"
                   value="car"
                   :checked="insurances.includes('car')"
            />
            <label for="car">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Pojazd</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/samochod.png"/>
          </div>
        </div>
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('travel'), 'dimmed': !this.insurances.includes('travel') }"
        >
        <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   id="travel"
                   class="insurance-checkbox"
                   value="travel"
                   :checked="insurances.includes('travel')"
            />
            <label for="travel">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body  d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Podróże</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/podroze.png"/>
          </div>
        </div>
      </div>
      <div class="insurance-item">
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('property'), 'dimmed': !this.insurances.includes('property') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="property"
                   value="property"
                   :checked="insurances.includes('property')"
            />
            <label for="property">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Nieruchomości</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/dom.png"/>
          </div>
        </div>
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('agricultural'), 'dimmed': !this.insurances.includes('agricultural') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="agricultural"
                   value="agricultural"
                   :checked="insurances.includes('agricultural')"
            >
            <label for="agricultural">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Rolne</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/rolnikszukaubezpieczenia.png"/>
          </div>
        </div>
      </div>
      <div class="insurance-item">
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('life'), 'dimmed': !this.insurances.includes('life') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="life"
                   value="life"
                   :checked="insurances.includes('life')"
            />
            <label for="life">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Życie</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/tarczaserce.png"/>
          </div>
        </div>
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('oc'), 'dimmed': !this.insurances.includes('oc') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="oc"
                   value="oc"
                   :checked="insurances.includes('oc')"
            />
            <label for="oc">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">OC zawodowe</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/biz.png"/>
          </div>
        </div>
      </div>
      <div class="insurance-item">
        <div class="ang-card d-flex align-items-center flex-column "
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('medicine'), 'dimmed': !this.insurances.includes('medicine') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="medicine"
                   value="medicine"
                   :checked="insurances.includes('medicine')"
            />
            <label for="medicine">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Pakiety medyczne</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/zdrowotne.png"/>
          </div>
        </div>
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('company'), 'dimmed': !this.insurances.includes('company') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="company"
                   value="company"
                   :checked="insurances.includes('company')"
            >
            <label for="company">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Firma</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/firma.png"/>
          </div>
        </div>
      </div>
      <div class="insurance-item">
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('nnw'), 'dimmed': !this.insurances.includes('nnw') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="nnw"
                   value="nnw"
                   :checked="insurances.includes('nnw')"
            />
            <label for="nnw">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">NNW</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/nnw.png"/>
          </div>
        </div>
        <div class="ang-card d-flex align-items-center flex-column"
             @click="selectOffer($event.currentTarget)"
             :class="{ 'bordered' : this.insurances.includes('others'), 'dimmed': !this.insurances.includes('others') }"
        >
          <div class="custom-checkbox custom-checkbox--small custom-checkbox--purple">
            <input type="checkbox"
                   class="insurance-checkbox"
                   id="others"
                   value="others"
                   :checked="insurances.includes('others')"
            />
            <label for="others">
              <svg class="checkbox" viewbox="0 0 40 40">
                <rect x="2" y="2" width="16" height="16"></rect>
                <polyline points="5,8 8,14 15,5"></polyline>
              </svg>
            </label>
          </div>
          <div class="ang-card-body d-flex align-items-center flex-column">
            <h4 class="ang-card-title">Inne</h4>
            <img width="100" class="img-responsive" src="/assets/img/apk-icons/inne.png"/>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mt-4">
      <div class="fc-red text-right mb-3">
        {{error}}
      </div>
      <button type="submit" class="btn btn-lg ang-button ang-btn-lg" @click="sendInsurances()">Dalej</button>
    </div>
  </div>
</template>

<script>
import spinner from "@/components/partials/misc/spinner"
import $ from "jquery"

export default {
  data () {
    return {
      loading: false,
      error: null,
      insurances: [],
    }
  },
  components: {
    spinner,
  },
  name: "insuranceTypes",
  mounted () {
    let self = this
    this.$nextTick(function () {
      self.scrollToAnchor('clientFormHeader')
    })
  },
  methods: {
    selectOffer (target) {
      this.error = null
      let el = target.querySelector('.insurance-checkbox')
      if (el.checked !== true) {
        this.insurances.indexOf(el.value) === -1 && this.insurances.push(el.value)
        el.checked = true
      } else {
        el.checked = false
        this.insurances.indexOf(el.value) !== -1 && this.insurances.splice(this.insurances.indexOf(el.value), 1)
      }
    },
    sendInsurances () {
      this.error = null
      if (this.insurances && this.insurances.length > 0) {
        this.$emit('selectedInsurancesTypes', this.insurances)
      } else {
        this.error = 'Musisz wybrać przynajmniej jeden typ ubezpieczenia.'
      }
    },
    scrollToAnchor (aid) {
      let aTag = $("#" + aid)
      if (typeof aTag !== 'undefined' && typeof aTag.offset() !== 'undefined') {
        $('html,body').animate({scrollTop: aTag.offset().top - 160}, 'slow')
      }
    }
  },
  watch: {
    agree () {
      let self = this
      this.$nextTick(function () {
        self.scrollToAnchor('clientFormHeader')
      })
       if (this.agree === 0) {
         this.insurances = []
       }
    }
  },
}
</script>
